import styled from 'styled-components';

export const DownloadInvoiceContainer = styled.div`
  display: flex;
  justify-content: center;
  border: 1px solid #e6e6eb;
  margin-top: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border-radius: ${props => props.roundness || '0px'};
  margin-left: 15px;
  margin-right: 15px;
  align-items: center;
`;

export const DownloadInvoiceText = styled.p`
  display: flex;
  margin-left: 12px;
`;

export const DownloadInvoiceAnchor = styled.a`
  text-decoration: none;
  color: inherit;
`;
